import { render, staticRenderFns } from "./PayConfig.vue?vue&type=template&id=c5aae504&scoped=true"
import script from "./PayConfig.vue?vue&type=script&lang=js"
export * from "./PayConfig.vue?vue&type=script&lang=js"
import style0 from "./PayConfig.vue?vue&type=style&index=0&id=c5aae504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5aae504",
  null
  
)

export default component.exports